import React from 'react'
import PropTypes from 'prop-types'
import ProductCardSkeleton from '../../../ProductCard/Skeleton'

import './index.css'

const ProductRecommendationsSkeleton = ({ className }) => (
  <div
    data-testid="product-recommendatios-skeleton"
    className={`product-recommendations-skeleton__wrapper ${className}`}
  >
    <ProductCardSkeleton />
    <ProductCardSkeleton className="d-none d-xs-flex" />
    <ProductCardSkeleton className="d-none d-sm-flex" />
    <ProductCardSkeleton className="d-none d-md-flex" />
    <ProductCardSkeleton className="d-none d-lg-flex" />
  </div>
)

ProductRecommendationsSkeleton.defaultProps = {
  className: '',
}

ProductRecommendationsSkeleton.propTypes = {
  className: PropTypes.string,
}

export default ProductRecommendationsSkeleton
